module.exports = __webpack_public_path__ + "static/media/aIMG_4564.d1976019.JPG";